<template>
    
    <div class="dropzone-square">
        <div class="dropzone-content">
            <div class="article-dropzone">
                <div class="d-flex justify-content-center align-items-center h-100">
                    <img v-if="imgObj.imgSrc" :src="imgObj.imgSrc" class="img-fluid" :alt="imgObj.alt">
                    <div v-else class="number guide-text">0{{ num }}</div> 
                </div>
                <figcaption class="d-none d-lg-block" v-if="imgObj" :role="imgObj ? 'alert' : ''">{{ imgObj.title }}</figcaption>
                <figcaption class="d-block d-lg-none" v-if="imgObj" :role="imgObj ? 'alert' : ''">{{ imgObj.label }}</figcaption>
            </div>
        </div>
        
    </div>
    
   
</template>

<script>
    export default {
        name: 'DropzoneRight',
        props: [
            'imgObj',
            'num'
        ]
    }
</script>

<style scoped>
    figcaption {
        /* position: absolute; */
        /* top: 100px; */
        width: 250px;
        line-height: 1.4em;
    }
    @media(min-width: 1020px){
        figcaption {
            /* top: 140px; */
        }
    }
    .dropzone-square {
        position: relative;
    }
    .dropzone-square:after{
        content: "";
        display: block;
        padding-bottom: 100%;
        background-color: #2f2523;
        transition: background-color 0.5s;
    }
    .dropzone-square.active:after{
        background-color: #ffd93d;
        
    }
    .dropzone-square .dropzone-content {
        position:absolute;
        width: 100%;
        height: 100%;
        right: 10px;
        top: -10px;
    }
    .dropzone-square,
    .article-dropzone {
        width: 50px;
        height: 50px;
    }
    .article-dropzone {
        background-color: #968c82;
        position: relative;
    }
    @media(min-width: 414px){
        .dropzone-square,
        .article-dropzone
         {
            width: 65px;
            height: 65px;
        }
    }
    @media(min-width: 768px){
        .dropzone-square,
        .article-dropzone
         {
            width: 100px;
            height: 100px;
        }
    }
    @media(min-width: 1020px){
        .dropzone-square,
        .article-dropzone
         {
            width: 150px;
            height: 150px;
        }
    }
    .number {
        color: white;
    }
</style>
